export default __webpack_public_path__ + "static/media/nouns-party.8a376df7.svg";